export default __webpack_public_path__ + "static/media/luuha.a619b12c.png";